import {i18n} from '@/plugins/i18next';

let NameColumn = {
  getColumns() {
    return [
      {label: i18n.t('book/issue:bread-crumbs.new'), code: 'TASK_NEW'},
      {label: i18n.t('book/issue:bread-crumbs.offer-requested'), code: 'OFFER_ADD'},
      {label: i18n.t('book/issue:bread-crumbs.offer-accepted'), code: 'OFFER_SIGN'},
      {label: i18n.t('book/issue:bread-crumbs.order-created'), code: 'CREATE_ORDER'},
      {label: i18n.t('book/issue:bread-crumbs.order-finished'), code: 'FINISH_ORDER'},
      {label: i18n.t('book/issue:bread-crumbs.invoice-requested'), code: 'INVOICE_ADD'},
      {label: i18n.t('book/issue:bread-crumbs.invoice-sent'), code: 'INVOICE_SEND'},
      {label: i18n.t('book/issue:bread-crumbs.success'), code: 'SUCCESS_TASK'}
    ]
  }
}

export default NameColumn;